import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const Disclaimer = () => {
  return (
    <section
      style={{
        background: 'var(--bg-secondary)',
        padding: '60px 7.6923%',
        borderTop: '1px solid var(--border-subtle)',
      }}
    >
      <div
        style={{
          maxWidth: '1000px',
          margin: '0 auto',
          display: 'flex',
          gap: '24px',
          alignItems: 'flex-start',
        }}
        className="disclaimer-container"
      >
        <div
          style={{
            flexShrink: 0,
            width: '56px',
            height: '56px',
            background: 'rgba(255, 193, 7, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AlertTriangle size={28} color="#FFC107" />
        </div>
        <div>
          <h3
            style={{
              fontSize: '24px',
              fontWeight: 600,
              color: 'var(--text-primary)',
              marginBottom: '12px',
            }}
          >
            Disclaimer
          </h3>
          <p
            style={{
              fontSize: '16px',
              lineHeight: 1.6,
              color: 'var(--text-secondary)',
              margin: 0,
            }}
          >
            BAiBOT inDriver adalah aplikasi otomasi pihak ketiga yang dikembangkan secara
            independen dan <strong>tidak berafiliasi dengan inDriver</strong>. Penggunaan
            aplikasi ini sepenuhnya menjadi tanggung jawab pengguna. Kami tidak bertanggung
            jawab atas konsekuensi yang mungkin timbul dari penggunaan aplikasi ini,
            termasuk namun tidak terbatas pada penangguhan atau pemblokiran akun oleh
            inDriver. Gunakan dengan bijak dan patuhi ketentuan layanan inDriver.
          </p>
        </div>
      </div>
      <style>
        {`
          @media (max-width: 767px) {
            .disclaimer-container {
              flex-direction: column;
            }
          }
        `}
      </style>
    </section>
  );
};